


export const ExcerptSection = () => (
  <div className="space-y-3">
    <div className="flex justify-between items-center">
      <h3 className="text-xs font-semibold uppercase text-muted-foreground">Excerpt</h3>
      <button className="text-xs text-primary hover:underline">Auto-generate</button>
    </div>
    <textarea className="w-full border bg-background rounded px-3 py-2 text-sm min-h-[80px]" placeholder="Brief summary..." />
  </div>
);
